import * as React from "react";
import { RouteType } from "src/routes/config";

// import ErrorPageLayout from "./ErrorPageLayout";
const BadRequest = React.lazy(()=> import("./4XX/400BadRequest"));
const Unauthorized = React.lazy(()=> import("./4XX/401Unauthorized"));
const NotFound = React.lazy(()=> import("./4XX/404NotFound"));
const ServerError = React.lazy(()=> import("./5XX/500ServerError"));

// TODO Agregar el resto de las rutas de error faltantes.
const errorRoutes: RouteType[] = [
    {
        path: "/400",
        element: <BadRequest />,
        state: "badrequest.default",
        functionId: -1,
    },
    {
        path: "/401",
        element: <Unauthorized />,
        state: "unauthorized.default",
        functionId: -1,
    },
    {
        path: "/404",
        element: <NotFound />,
        state: "notfound.default",
        functionId: -1,
    },
    {
        path: "/500",
        element: <ServerError />,
        state: "servererror.default",
        functionId: -1,
    }
];

export default errorRoutes;
